/* eslint-disable prefer-const */
import {
  Button,
  Col,
  message,
  notification,
  Pagination,
  Row,
  Table,
  Dropdown,
  Menu,
  Popconfirm,
  Space,
  Modal,
  Popover,
} from 'antd'
import { ExclamationCircleFilled, PlusOutlined } from '@ant-design/icons'
import React, { useEffect, useRef, useState } from 'react'
import axios, { CancelTokenSource } from 'axios'
import styles from './Commodity.module.css'
import { AGColumns } from './columns'
import { useDispatch, useSelector } from 'react-redux'
import {
  pageCommodity,
  selectCommodityData,
  selectorTotal,
  logoutOrenableCommodity,
  setSelectId,
  commodityLogoutOrEnableListAsync,
  saveCodeMedicalListAsync,
  delCodeMedicalListAsync,
  updateCatalogAsync,
  revokeCatalogAsync,
  selectPageLoading,
  setPageLoading,
  commodityExportExcelAsync,
  copyCatalogAsync,
  getMaterialIdsByParamAsync,
  savePriceTagCatalogAsync,
  deletePriceTagCatalogAsync,
} from './commoditySlice'
import { Commodityquery } from './query'
import { commodityPageParams } from '../../services/commodity'
import { DataType } from '../putstorage/putstorage'
import { useHistory } from 'react-router'
import { EditableList } from '../../compnents/list/EditableList'
import { CommodityModal } from './CommodityModal'
import { CommodityLastEditModal } from './CommodityLastEditModal'
import { CommodityMedicareModal } from './CommodityMedicareModal'
import { current, unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { curry } from 'lodash'
import { TableRowSelection } from 'antd/lib/table/interface'
import { MedicalModal } from './medical/MedicalModal'
import {
  selectApiUserType,
  selectChainId,
  selectChainType,
  selectCycleCode,
  selectInsuranceArray,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantId,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../../app/applicationSlice'
import { MedicalItem } from '../../models/material'
import { DateTimeFormatSimpleOnlyOne } from '../../models/datetime'
import moment from 'moment'
import { medicalSendHttp, strParse } from '../../utils/MedicalUtils'
import { PurchaseModal } from '../putstorelist/purchaseModal'
import { PrintTemplateModal } from '../print/PrintTemplateModal'
import { PrintTemplateCategory } from '../../models/print'
import { ThemeContext } from '../../theme/ThemeContext'
import {
  getSynchrGoodsFn,
  postTTickSynchrGoodsFn,
  getSyncMaterialsCatalogFn,
  getPushMaterialsCatalogFn,
} from '../chainTransferApplication/chainSlice'
import { getAddFirstBussinessAsync } from '../firstTimeBusinessManagement/varietyManagement/varietyManagementSlice'
import { getPageColumnListAsync, getSubmitPageColumnListAsync } from '../transactionQuery/transactionQuerySlice'
import SimpleAgGrid from '../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../models/common'
import { SJQXChecks } from '../../models/dataPersion'
import { getCheckPermissionAsync } from '../FunctionSetting/dataPermission/dataPermissionSlice'
import { Checks } from '../../models/personalSetting'
import { YJTBJGModal } from './YJTBXJDMLSJModal'
import { YJTBXJDMLKCModal } from './YJTBXJDMLKCModal'
import { PriceTagPrintModal, PriceTagPrintModalRef } from './priceTagPrintModal'

let isWubi = ''

const getMaterialsCategoryQueryParams = (queries: commodityPageParams) => {
  const materialsCategoryList = queries?.materialsCategoryList

  if (queries?.materialsCategory || queries?.category) {
    return {
      materialsCategory: queries?.materialsCategory,
      category: queries?.category,
    }
  }

  if (Array.isArray(materialsCategoryList) && Array.isArray(materialsCategoryList[0])) {
    const materialsCategory = Array.from(
      new Set(
        materialsCategoryList
          .map((item: any) => item?.[0])
          .filter((item: any) => item !== undefined && item !== null && item !== '')
      )
    ).join(',')
    const category = Array.from(
      new Set(
        materialsCategoryList
          .map((item: any) => item?.[1])
          .filter((item: any) => item !== undefined && item !== null && item !== '')
      )
    ).join(',')

    return {
      materialsCategory: materialsCategory || undefined,
      category: category || undefined,
    }
  }

  return {
    materialsCategory: Array.isArray(materialsCategoryList) ? materialsCategoryList?.[0] : undefined,
    category: Array.isArray(materialsCategoryList) ? materialsCategoryList?.[1] : undefined,
  }
}

export const Commodity = (props: {
  isHome?: boolean // 首页消息通知弹框目录更新
}) => {
  const history = useHistory()

  const dispatch = useDispatch<RootDispatch>()

  const insuranceArray = useSelector(selectInsuranceArray)

  const tenantCategory = useSelector(selectTenantCategory) //17校医务室

  const apiUserType = useSelector(selectApiUserType)

  const [visible, setVisible] = useState(false)

  const [queries, setQueries] = useState<commodityPageParams>({
    state: 1,
    size: 10,
    current: 0,
  })

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 62,
      minWidth: 62,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '商品信息',
      field: 'name',
      width: 300,
      minWidth: 300,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '商品编码',
      field: 'no',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '产地',
      field: 'origin',
      minWidth: 160,
      visible: false,
    },
    /* 0512通用名修改 通用名->商品名 */
    {
      headerName: '商品名',
      field: 'genericName',
      minWidth: 160,
      visible: true,
    },
    // 非医保不展示 ( 医保国码、医保限价)
    {
      headerName: '医保国码',
      field: 'hilistCode',
      minWidth: 250,
      visible: true,
    },
    {
      headerName: '医保限价',
      field: 'priceLimit',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '批准文号',
      field: 'approvalNumber',
      minWidth: 180,
      visible: true,
    },
    {
      headerName: '拆零标志',
      field: 'splitTag',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '商品类别',
      field: 'materialsCategory',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '开票项目',
      field: 'billingCategory',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '零售价',
      field: 'retailPrice',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '进价',
      field: 'unitPrice',
      minWidth: 90,
      visible: false,
    },
    {
      headerName: 'OTC标志',
      field: 'otc',
      minWidth: 90,
      visible: true,
    },
    // 非医保不展示 ( 是否国谈药、是否省招、匹配状态)
    {
      headerName: '是否国谈药',
      field: 'natNegoDrugFlag',
      align: 'center',
      minWidth: 100,
      visible: true,
    },
    {
      headerName: '是否省招',
      field: 'provinceTendFlag',
      minWidth: 90,
      visible: true,
    },
    {
      headerName: '包装材质',
      field: 'pacmatl',
      minWidth: 96,
      visible: false,
    },
    {
      headerName: '匹配状态',
      field: 'approveFlg',
      minWidth: 96,
      visible: true,
    },
    {
      headerName: '创建时间',
      field: 'createTime',
      minWidth: 170,
      sortable: true,
      visible: true,
    },
    {
      headerName: '最近一次修改',
      field: 'lastUpdateTime',
      minWidth: 170,
      sortable: true,
      visible: true,
    },
    {
      headerName: '状态',
      field: 'state',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 220,
      minWidth: 220,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v, index) => {
    return {
      ...v,
      index: index + 1,
    }
  })

  const allColumnData = listData

  // 默认要展示的列的值
  const selectColumns = allColumnData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  const [columnQueryFilterList, setColumnQueryFilterList] = useState<any[]>([])

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [scrollHeight, setScrollHeight] = useState<any>()

  const tenantId = useSelector(selectTenantId)

  const chainId = useSelector(selectChainId)

  const [selectIds, setSelectIds] = useState<any>([])

  const [modalSelectIds, setModalSelectIds] = useState<any>([])

  const [selectRow, setSelectRow] = useState<any>([])

  const [IsModalVisible, setIsModalVisible] = useState(false)

  const [IsMedicareModalVisible, setIsMedicareModalVisible] = useState(false)

  const [isPurchaseModalVisible, setIsPurchaseModalVisible] = useState(false)

  const [medicalModalVisible, setMedicalModalVisible] = useState(false)

  const [selectText, setSelectText] = useState<any>()

  const [printIds, setPrintIds] = useState<any>()

  const [componentItem, setComponentItem] = useState<any>()

  const [batchModalTitle, setbatchModalTitle] = useState<any>()

  const [isPrintModalVisible, setIsPrintModalVisible] = useState(false)

  const [isPriceTagPrintModalVisible, setIsPriceTagPrintModalVisible] = useState(false)

  const priceTagPrintModalRef = useRef<PriceTagPrintModalRef>(null)

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const [pageSelections, setPageSelections] = useState<Record<string, any[]>>({})

  const pageLoadingRX: any = useSelector(selectPageLoading)

  const data = useSelector(selectCommodityData)

  const total = useSelector(selectorTotal)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const [selectCatMappingIds, setSelectCatMappingIds] = useState<number[]>([])

  const [exportBtnLoading, setExportBtnLoading] = useState(false)

  const [syncLoading, setSyncLoading] = useState(false)

  const [syncGoodsLoading, setSyncGoodsLoading] = useState(false)

  const [lastEditId, setLastEditId] = useState<any>()

  const [lastEditVisable, setLastEditVisable] = useState(false)

  const [isYJTBModalVisible, setIsYJTBModalVisible] = useState(false) //一键同步限价到售价

  const [isYJTBXJDMLKCModalVisible, setIsYJTBXJDMLKCModalVisible] = useState(false) //一键同步限价到库存

  const cycleCode = sessionStorage?.getItem('cycleCode')

  const chainType = useSelector(selectChainType)

  const [allData, setAllData] = useState<any>([])

  const [sortedInfo, setSorter] = useState<any>()

  const [KFGZZCKLRSJData, setKFGZZCKLRSJData] = useState<any>(true)

  // 库房工作站查看利润数据
  useEffect(() => {
    dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZCKLRSJ }))
      .then(unwrapResult)
      .then((res: any) => {
        setKFGZZCKLRSJData(res)
      })
  }, [])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'storageStation',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'storageStation',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const resetData = data?.map(((v: any) => {
          const sameFileds = allColumnData?.find((item: any) => item?.field == v?.field)
          return {
            ...v,
            minWidth: sameFileds?.minWidth || v?.minWidth,
            width: sameFileds?.width || v?.width,
            headerName: sameFileds?.headerName || v?.headerName,
          }
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allColumnData)
        // 筛选后存在后端的数据

        setFilterColumnList(filterList?.length ? filterList : allColumnData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allColumnData)
        setFilterColumnList(allColumnData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        dispatch(setPageLoading(false))
      })
  }

  useEffect(() => {
    if (allColumnList?.length) {
      // 非医保情况下过滤 （医保国码 hilistCode /医保限价 priceLimit / 是否国谈药 natNegoDrugFlag / 是否省招 provinceTendFlag / 匹配状态 approveFlg）
      const insuranceListData = insuranceArray.length ? allColumnList : allColumnList?.filter((v: any) => v.field != 'hilistCode' && v.field != 'priceLimit' && v.field != 'natNegoDrugFlag' && v.field != 'provinceTendFlag' && v.field != 'approveFlg' && v.field != 'pacmatl')
      // tenantCategory == 17 校医务室
      // queries?.materialsCategory == '0' 药品  
      const columnData = queries?.materialsCategory == '0' ? (
        //  如果是校医务室过滤 （零售价 retailPrice  /最近一次修改 lastUpdateTime）
        tenantCategory == 17 ? insuranceListData?.filter((v: any) => v.field != 'retailPrice' && v.field != 'lastUpdateTime')
          : insuranceListData
      ) : (
        //  如果是非药品且是校医务室过滤 （零售价 retailPrice  /最近一次修改 lastUpdateTime / 通用名 genericName）
        tenantCategory == 17 ? insuranceListData?.filter((v: any) => v.field != 'retailPrice' && v.field != 'lastUpdateTime' && v.field != 'genericName')
          : insuranceListData?.map((v: any) => ({
            ...v,
            visible: v?.field == 'genericName' ? false : v?.visible,
          }))
      )
      setColumnQueryFilterList(columnData)
    }
  }, [allColumnList])

  useEffect(() => {
    if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'createTime'
    ) {
      setQueries({
        ...queries,
        createTimeSort: 0,
        lastUpdateTimeSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'createTime'
    ) {
      setQueries({
        ...queries,
        createTimeSort: 1,
        lastUpdateTimeSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'ascend' &&
      sortedInfo?.columnKey === 'lastUpdateTime'
    ) {
      setQueries({
        ...queries,
        lastUpdateTimeSort: 0,
        createTimeSort: undefined,
      })
    } else if (
      sortedInfo?.order === 'descend' &&
      sortedInfo?.columnKey === 'lastUpdateTime'
    ) {
      setQueries({
        ...queries,
        lastUpdateTimeSort: 1,
        createTimeSort: undefined,
      })
    } else if (sortedInfo && sortedInfo?.order == undefined) {
      setQueries({
        ...queries,
        createTimeSort: undefined,
        lastUpdateTimeSort: undefined,
      })
    }
  }, [sortedInfo])
  const menu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          history.push({
            pathname: '/durgsaveform',
            state: { materialCategory: 0 },
          })
        }}
      >
        药品
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          history.push({
            pathname: '/materialsaveform',
            state: { materialCategory: 1 },
          })
        }}
      >
        材料
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          history.push({
            pathname: '/apparatussaveform',
            state: { materialCategory: 2 },
          })
        }}
      >
        器械
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          history.push({
            pathname: '/nondurgsaveform',
            state: { materialCategory: 4 },
          })
        }}
      >
        其他
      </Menu.Item>
    </Menu>
  )

  const medicalMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          cycleCode
            ? updataCatalog('requestString')
            : notificationInfo(
              '请先点击右上角【医保业务】-【签到】按钮后，刷新页面再试。'
            )
        }}
      >
        上传勾选目录
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          cycleCode
            ? updataCatalog('requestString', true)
            : notificationInfo(
              '请先点击右上角【医保业务】-【签到】按钮后，刷新页面再试。'
            )
        }}
      >
        上传本页全部目录
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          cycleCode
            ? revokeCatalog('requestString')
            : notificationInfo(
              '请先点击右上角【医保业务】-【签到】按钮后，刷新页面再试。'
            )
        }}
      >
        撤销勾选目录
      </Menu.Item>
    </Menu>
  )

  const priceTagPrintMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          if (!selectIds.length) {
            notification.info({
              message: '请先选择商品',
            })
          } else {
            setSelectText('打印勾选项')
            setIsPrintModalVisible(true)
          }
        }}
      >
        打印勾选项
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          setSelectText('仅打印有库存的商品')
          dispatch(getMaterialIdsByParamAsync({ type: 1 }))
            .then(unwrapResult)
            .then((v: any) => {
              setPrintIds(v)
              if (v?.length) {
                setIsPrintModalVisible(true)
              } else {
                notification.info({
                  message: '暂无可打印数据',
                })
              }
            })
        }}
      >
        仅打印有库存的商品
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          if (!selectIds.length) {
            notification.info({
              message: '请先选择商品',
            })
          } else {
            dispatch(savePriceTagCatalogAsync(selectIds))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: '操作成功',
                })
                setSelectIds([])
                setSelectRow([])
              })
          }
        }}
      >
        生成价签目录
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          setIsPriceTagPrintModalVisible(true)
        }}
      >
        价签目录打印
      </Menu.Item>
    </Menu>
  )

  const oneClickSynchronizationMenu = (
    <Menu>
      {/* 自费机构（未开通医保）不展示一键同步限价到目录售价 */}
      {insuranceArray.length ? <Menu.Item
        onClick={() => {
          setIsYJTBModalVisible(true)
        }}
      >
        一键同步限价到目录售价
      </Menu.Item> : <></>}
      <Menu.Item
        onClick={() => {
          setIsYJTBXJDMLKCModalVisible(true)
        }}
      >
        一键同步目录售价到库存售价
      </Menu.Item>
    </Menu>
  )

  const batchAddMenu = (
    <Menu>
      <Menu.Item
        onClick={() => {
          // cycleCode
          // ? updataCatalog('requestString')
          // : notificationInfo('请先签到')
          setIsModalVisible(true)
          setbatchModalTitle('标准目录库')
        }}
      >
        标准目录库
      </Menu.Item>
      <Menu.Item
        onClick={() => {
          if (insuranceArray.length) {
            setComponentItem({
              name: '',
              billingCategory: '01',
              tenantSupplierName: '',
              transitionScale: '',
              approvalNumber: '',
            })
            setIsMedicareModalVisible(true)
            setbatchModalTitle('医保目录库')
          } else {
            notification.info({
              message: '未开通医保业务，请联系客服开通',
            })
          }
        }}
      >
        医保目录库
      </Menu.Item>
    </Menu>
  )

  const getDeleteJQ = (v?: any[]) => {
    dispatch(deletePriceTagCatalogAsync(v || []))
      .then(unwrapResult)
      .then((v: any) => {
        notification.success({
          message: '操作成功',
        })
        setSelectIds([])
        setSelectRow([])
        priceTagPrintModalRef.current?.refresh()
      })
  }

  const removeDuplicatesById = (arr: any[]) => {
    const map = new Map()
    arr.forEach((item: any) => {
      map.set(item.id, item)
    })
    return Array.from(map.values())
  }

  const success = (str: string) => {
    const hide = message.loading(str, 0)
    // Dismiss manually and asynchronously
    setTimeout(hide, 1500)
  }

  const notificationInfo = (str: string) => {
    notification.info({
      message: str,
    })
  }

  const routerChange = (d: any) => {
    switch (d?.materialsCategory) {
      case 0:
        history.push({
          pathname: '/durgsaveform',
          state: {
            materialCategory: 0,
            record: {
              ...insuranceItem,
              ...d,
            },
          },
        })
        break
      case 1:
        history.push({
          pathname: '/materialsaveform',
          state: {
            materialCategory: 1,
            record: {
              ...insuranceItem,
              ...d,
            },
          },
        })
        break
      case 2:
        history.push({
          pathname: '/apparatussaveform',
          state: {
            materialCategory: 2,
            record: {
              ...insuranceItem,
              ...d,
            },
          },
        })
        break
      case 4:
        history.push({
          pathname: '/nondurgsaveform',
          state: {
            materialCategory: 4,
            record: {
              ...insuranceItem,
              ...d,
            },
          },
        })
        break
      default:
        break
    }
  }

  // const rowSelection = {
  //   preserveSelectedRowKeys: true,
  //   onChange: (selectedRowKeys: React.Key[], selectedRows: DataType[]) => {
  //     setSelectIds(selectedRowKeys)
  //     setSelectCatMappingIds(
  //       selectedRows
  //         .map((v: any) => {
  //           if (v.mappingId) {
  //             if (v.approveFlg !== '1') {
  //               return v.mappingId
  //             } else {
  //               return
  //             }
  //           } else {
  //             return
  //           }
  //         })
  //         .filter((v: number) => v)
  //     )
  //     setSelectRow(selectedRows)
  //   },
  // }

  // 启用或注销数据
  const logoutOrEnable = (state: any, forceRemove?: number) => {
    // if (!selectIds.length) {
    //   notification.info({
    //     message: '请先选择商品',
    //   })
    // } else {
    dispatch(
      commodityLogoutOrEnableListAsync({
        state: state,
        ids: selectIds.join(','),
        forceRemove: forceRemove,
      })
    )
      .then(unwrapResult)
      .then(() => {
        setQueries({
          ...queries,
          current: 1,
        })
      })
    // }
  }

  // 获取分页数据
  const pageCancelRef = useRef<CancelTokenSource | null>(null)
  const getPage = () => {
    const allPersonalPreferences = JSON.parse(localStorage?.getItem('allPersonalPreferences') || '{}')
    const isWubi = allPersonalPreferences?.records?.filter((v: any) => v?.code == Checks.SRFSZ)?.[0]?.codeName || 0
    dispatch(setPageLoading(true))
    onResize() // 初始化设置高度
    window.addEventListener('resize', onResize)
    pageCancelRef.current?.cancel()
    const source = axios.CancelToken.source()
    pageCancelRef.current = source
    dispatch(
      pageCommodity({
        ...queries,
        materialsCategoryList: undefined,
        ...getMaterialsCategoryQueryParams(queries),
        insuranceCode:
          queries.insuranceCode || insuranceArray[0]?.insuranceCode,
        isWubi: isWubi || 0,
      }, source.token)
    )
    setTimeout(() => {
      dispatch(setPageLoading(false))
    }, 3000)
  }

  // 上传医保数据
  const updataCatalog = async (serverType: any, isAll?: boolean) => {
    const catMappingIds = (isAll ? data : selectRow)
      .map((v: any) => {
        if (v.approveFlg !== '1') {
          if (v.rewriteHilistCode) {
            return "###" + v.id
          } else if (v.mappingId) {
            return v.mappingId
          } else {
            return
          }
        } else {
          return
        }

      })
      .filter((v: number) => v)
    let promiseData: any = []
    if (catMappingIds.length) {
      await catMappingIds.forEach((v: number) => {
        // updataCatalogItem(serverType, v)
        promiseData.push(
          new Promise((resolve, reject) => {
            updataCatalogItem(serverType, v, resolve, reject)
          })
        )
      })
      success('上传中')
      Promise.allSettled(promiseData).then((settled: any) => {
        const success: any = settled.filter(
          (v: any) => v.status === 'fulfilled'
        )
        const error: any = settled.filter((v: any) => v.status === 'rejected')
        const msgContent = (
          <div>
            上传完毕，本次共上传{settled.length}条，成功{success.length}条，失败
            {error.length}条，
            {error.length > 0 ? (
              <>
                <Row>详细信息如下：</Row>
                {error.map((v: any, i: number) => {
                  if (!v?.reason?.message) {
                    return <div key={i}>{v?.reason}</div>
                  } else {
                    return (
                      <div
                        key={i}
                        dangerouslySetInnerHTML={{ __html: v?.reason?.message }}
                      ></div>
                    )
                  }
                })}
              </>
            ) : (
              ''
            )}
          </div>
        )
        if (success.length == 0) {
          notification.error({
            message: msgContent,
            duration: 3,
          })
        } else if (success.length == settled.length) {
          notification.success({
            message: msgContent,
            duration: 3,
          })
        } else {
          notification.warn({
            message: msgContent,
            duration: 3,
          })
        }
        // notification.success({
        //   message: `上传成功，本次共上传${settled.length}条，成功${success.length}条，失败${error.length}条`,
        //   duration: 3,
        // })
        getPage()
        setSelectIds([])
        setSelectRow([])
      })
    } else {
      notificationInfo('请选择已匹配医保代码商品，和未上传商品')
    }
  }

  const updataCatalogItem = (
    serverType: any,
    catMappingId: number,
    resolve: any,
    reject: any
  ) => {
    dispatch(
      updateCatalogAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
          },
          catMappingIds: [catMappingId],
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: string) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data.data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (!err) {
                updataCatalogItem('response', catMappingId, resolve, reject)
              }
            },
            undefined,
            reject
          )
        } else {
          resolve()
        }
      })
      .catch((err) => {
        reject(err)
      })
  }

  // 撤销上传
  const revokeCatalog = async (serverType: any) => {
    const catMappingIds = selectRow
      .map((v: any) => {
        if (v.approveFlg === '1') {
          if (v.rewriteHilistCode) {
            return "###" + v.id
          } else if (v.mappingId) {
            return v.mappingId
          } else {
            return
          }
        } else {
          return
        }

      })
      .filter((v: number) => v)
    let promiseData: any = []
    if (catMappingIds.length) {
      await catMappingIds.forEach((v: number) => {
        promiseData.push(
          new Promise((resolve, reject) => {
            revokeCatalogItem(serverType, v, resolve, reject)
          })
        )
      })
      success('撤销中')
      Promise.allSettled(promiseData).then((settled: any) => {
        const success: any = settled.filter(
          (v: any) => v.status === 'fulfilled'
        )
        const error: any = settled.filter((v: any) => v.status === 'rejected')
        const msgContent = (
          <div>
            撤销完毕，本次共撤销{settled.length}条，成功{success.length}条，失败
            {error.length}条，
            {error.length > 0 ? (
              <>
                <Row>详细信息如下：</Row>
                {error.map((v: any, i: number) => {
                  if (!v?.reason?.message) {
                    return <div key={i}>{v?.reason}</div>
                  } else {
                    return (
                      <div
                        key={i}
                        dangerouslySetInnerHTML={{ __html: v?.reason?.message }}
                      ></div>
                    )
                  }
                })}
              </>
            ) : (
              ''
            )}
          </div>
        )
        if (success.length == 0) {
          notification.error({
            message: msgContent,
            duration: 3,
          })
        } else if (success.length == settled.length) {
          notification.success({
            message: msgContent,
            duration: 3,
          })
        } else {
          notification.warn({
            message: msgContent,
            duration: 3,
          })
        }

        getPage()
        setSelectIds([])
        setSelectRow([])
      })
    } else {
      notificationInfo('请选择已匹配医保代码商品，和已上传商品')
    }
  }

  const revokeCatalogItem = (
    serverType: any,
    catMappingId: number,
    resolve: any,
    reject: any
  ) => {
    dispatch(
      revokeCatalogAsync({
        serverType: serverType,
        body: {
          baseData: {
            ...insuranceItem,
            endTime: moment(insuranceItem.endTime).format(
              DateTimeFormatSimpleOnlyOne
            ),
            userName,
            userId,
            cycleCode,
            tenantCategory,
            tenantAreaCd,
            name: tenantName,
            address: tenantAddress,
            areaCode: tenantAreaCd,
          },
          catMappingIds: [catMappingId],
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: string) => {
        if (serverType === 'requestString') {
          const data = JSON.parse(res.replace(/\\"/g, '"'))
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data.data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call, err) => {
              if (!err) {
                revokeCatalogItem('response', catMappingId, resolve, reject)
              }
            },
            undefined,
            reject
          )
        } else {
          resolve()
        }
      })
      .catch((err) => {
        reject(err)
      })
  }

  // 匹配医保目录
  const saveMedicalCode = (item: MedicalItem) => {
    dispatch(
      saveCodeMedicalListAsync({
        billing_category: componentItem.billingCategory,
        hilist_code: item?.hiListCode,
        insuranceCode: queries.insuranceCode || insuranceArray[0].insuranceCode,
        is_reimbursement: item?.isCouldBx,
        local_item_id: String(componentItem?.id),
        limitId: item.limitId,
        rid: item?.rid,
        proviceHilistCode: item?.proviceHilistCode,
      })
    )
      .then(unwrapResult)
      .then(() => {
        getPage()
        notification.success({
          message: '匹配成功',
        })
      })
  }

  // 撤销匹配医保目录
  const delNedicalCode = (item: any) => {
    if (item.approveFlg !== '1') {
      dispatch(
        delCodeMedicalListAsync({
          insuranceCode:
            queries.insuranceCode || insuranceArray[0].insuranceCode,
          mapping_id: String(item?.mappingId),
          localItemId: item?.id,
          medicalType: 1,
        })
      )
        .then(unwrapResult)
        .then(() => {
          getPage()
          notification.success({
            message: '撤销匹配成功',
          })
        })
    } else {
      notification.info({
        message: '不可删除已上传的匹配记录!',
      })
    }
  }

  useEffect(() => {
    const newData = removeDuplicatesById([...data, ...allData])
    setAllData(newData)
  }, [data])

  useEffect(() => {
    if (insuranceArray.length) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  useEffect(() => {
    return () => {
      pageCancelRef.current?.cancel()
    }
  }, [])

  useEffect(() => {
    if (!queries.current) return
    // 69 开头的 13 位为 EAN-13 条码，输满 13 位才搜索；8 位的 69 开头编码也要触发搜索
    if (
      queries.allStr &&
      queries.allStr.indexOf('69') == 0 &&
      queries.allStr.length < 13 &&
      queries.allStr.length !== 8
    )
      return

    const insuranceItem = insuranceArray.find(
      (v) => v.insuranceCode == queries.insuranceCode
    )
    if (insuranceItem) {
      setInsuranceItem(insuranceItem)
    }
    getPage()
    getPageColumnList()
    if (queries) {
      sessionStorage?.setItem('/commodity', JSON.stringify(queries))
    }
  }, [queries])

  useEffect(() => {
    setSelectIds([])
  }, [queries.state])

  const outExportExcel = () => {
    setExportBtnLoading(true)
    dispatch(
      commodityExportExcelAsync({
        ...queries,
        materialsCategoryList: undefined,
        ...getMaterialsCategoryQueryParams(queries),
        insuranceCode:
          queries.insuranceCode || insuranceArray[0]?.insuranceCode,
        checkItemIds: selectIds.join(','),
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '商品管理.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .finally(() => {
        setExportBtnLoading(false)
        setQueries({
          ...queries,
          current: 1,
          size: 10,
        })
        setSelectIds([])
        setSelectRow([])
      })
  }

  const onResize = () => {
    const table = document.getElementById('tableHeightCommodity')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 30
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  const getAddFirstBussiness = (tenantMaterialsCatalogId?: any) => {
    dispatch(getAddFirstBussinessAsync(tenantMaterialsCatalogId))
      .then(unwrapResult)
      .then((v: any) => {
        notification.success({
          message: '操作成功',
        })
        getPage()
      })
  }

  return (
    <div className={styles.root}>
      <Row gutter={10} justify='space-between'>
        <Space>
          <Dropdown overlay={menu} trigger={['click']}>
            <Button
              type='primary'
              icon={<PlusOutlined />}
              className={styles.add}
            >
              新增目录<i className={styles.icon}></i>
            </Button>
          </Dropdown>
          {tenantCategory == 17 ? <></> : <Dropdown overlay={batchAddMenu} trigger={['click']}>
            <Button
              type='primary'
              icon={<PlusOutlined />}
              className={styles.add}
            >
              批量添加<i className={styles.icon}></i>
            </Button>
          </Dropdown>}
          {/* 自费机构（未开通医保）不展示医保操作 */}
          {tenantCategory == 17 || !insuranceArray.length ? <></> : <Dropdown overlay={medicalMenu} trigger={['click']}>
            <Button
              type='primary'
              icon={<PlusOutlined />}
              className={styles.add}
            >
              医保操作<i className={styles.icon}></i>
            </Button>
          </Dropdown>}
        </Space>

        {/* <Button
            type='primary'
            className={styles.add}
            onClick={() => {
              setIsModalVisible(true)
            }}
          >
            标准数据
          </Button> */}
        <Space>
          {tenantId == chainId && chainType == 1 && (
            <Button
              type='primary'
              loading={syncGoodsLoading}
              onClick={() => {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认商品同步？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    if (!selectIds.length) {
                      notification.error({
                        message: '请先勾选同步内容',
                        duration: 3,
                      })
                      return
                    }
                    setSyncGoodsLoading(true)
                    dispatch(postTTickSynchrGoodsFn(selectIds))
                      .then(unwrapResult)
                      .then((v: any) => {
                        notification.success({
                          message: v || '商品同步成功',
                          duration: 3,
                        })
                        getPage()
                      })
                      .finally(() => {
                        setSyncGoodsLoading(false)
                      })
                  },
                })
              }}
            >
              商品同步{selectIds.length ? ` ${selectIds.length} 条` : ''}
            </Button>
          )}
          {chainId > 0 && tenantId != chainId && (
            <Button
              type='primary'
              loading={syncLoading}
              onClick={() => {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认目录同步？
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '取消',
                  icon: null,
                  onOk: () => {
                    setSyncLoading(true)
                    dispatch(getSyncMaterialsCatalogFn())
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '目录同步成功',
                          duration: 3,
                        })
                        getPage()
                      })
                      .finally(() => {
                        setSyncLoading(false)
                      })
                  },
                })
              }}
            >
              目录同步
            </Button>
          )}
          {chainId > 0 && tenantId == chainId && (
            <Button
              type='primary'
              loading={syncLoading}
              onClick={() => {
                Modal.confirm({
                  centered: true,
                  title: '确认操作',
                  content: (
                    <div>
                      <ExclamationCircleFilled
                        style={{ color: '#FFAE55', fontSize: 18 }}
                      />
                      &nbsp;是否确认推送目录更新？<br /> 该操作将会更新所有分店的目录
                    </div>
                  ),
                  okText: '确认',
                  cancelText: '再次核对',
                  icon: null,
                  onOk: () => {
                    setSyncLoading(true)
                    dispatch(getPushMaterialsCatalogFn())
                      .then(unwrapResult)
                      .then(() => {
                        notification.success({
                          message: '目录更新推送成功',
                          duration: 3,
                        })
                        getPage()
                      })
                      .finally(() => {
                        setSyncLoading(false)
                      })
                  },
                })
              }}
            >
              目录更新推送
            </Button>
          )}
          {apiUserType !== 'SYLD' &&
            <Dropdown overlay={oneClickSynchronizationMenu} trigger={['click']}>
              <Button type='primary'>
                一键同步价格<i className={styles.icon}></i>
              </Button>
            </Dropdown>
          }
          <Dropdown overlay={priceTagPrintMenu} trigger={['click']}>
            <Button type='primary'>
              价格标签打印<i className={styles.icon}></i>
            </Button>
          </Dropdown>
          <Button
            type='primary'
            loading={exportBtnLoading}
            onClick={(() => {
              dispatch(getCheckPermissionAsync({ itemCode: SJQXChecks.KFGZZDCDYQX }))
                .then(unwrapResult)
                .then((res: any) => {
                  outExportExcel()
                })
            })}
          >
            导出
          </Button>
          <Button
            type='primary'
            onClick={() => {
              setIsPurchaseModalVisible(true)
            }}
          >
            导入商品目录
          </Button>
          {queries.state ? (
            selectIds?.length ?
              <Popover
                trigger="click"
                title=''
                visible={visible}
                onVisibleChange={(v) => setVisible(v)}
                content={
                  <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <Space style={{ lineHeight: '32px', marginBottom: '10px' }}>
                      <ExclamationCircleFilled
                        style={{
                          color: '#FFAE55',
                          fontSize: 18,
                          marginTop: '6px'
                        }}
                      /> 确认进行注销操作？
                    </Space>
                    <Space direction="vertical" size={12} className={styles.zxButtons}>
                      <Button block ghost type="primary" onClick={() => {
                        logoutOrEnable(0)
                        setVisible(false)
                      }} >只注销商品信息</Button>
                      <Button block danger onClick={() => {
                        setVisible(false)
                        Modal.confirm({
                          centered: true,
                          title: '',
                          content: (
                            <div>
                              <ExclamationCircleFilled
                                style={{ color: '#FFAE55', fontSize: 18 }}
                              />
                              &nbsp;注销并同步删除套餐/未收费处方<br /> <span style={{ marginLeft: '24px' }}>删除后不可恢复，请谨慎操作</span>
                            </div>
                          ),
                          okText: '确定',
                          cancelText: '取消',
                          icon: null,
                          onOk: () => {
                            logoutOrEnable(0, 1)
                          },
                        })
                      }} >注销并删除套餐/未收费处方</Button>
                      <Button block danger onClick={() => {
                        setVisible(false)
                        Modal.confirm({
                          centered: true,
                          title: '',
                          content: (
                            <div>
                              <ExclamationCircleFilled
                                style={{ color: '#FFAE55', fontSize: 18 }}
                              />
                              &nbsp;注销并同步删除商品信息和套餐/未收费处方<br /> <span style={{ marginLeft: '24px' }}>删除后不可恢复，请谨慎操作</span>
                            </div>
                          ),
                          okText: '确定',
                          cancelText: '取消',
                          icon: null,
                          onOk: () => {
                            logoutOrEnable(2, 1)
                          },
                        })

                      }} >注销并删除商品信息</Button>
                    </Space></div>
                }
              >
                <Button type='primary'>{queries.state ? '注销' : '启用'}</Button>
              </Popover> :
              <Button
                type='primary'
                onClick={() => {
                  notification.info({
                    message: '请先选择商品',
                  })
                }}>{queries.state ? '注销' : '启用'}</Button>
          ) : (
            <Popconfirm
              title={'确认进行启用操作？'}
              onConfirm={() => {
                logoutOrEnable(1)
              }}
              onCancel={() => {
                return
              }}
              okText='确认'
              cancelText='取消'
            >
              <Button type='primary'>{queries.state ? '注销' : '启用'}</Button>
            </Popconfirm>
          )}

          {/*<Popconfirm*/}
          {/*  title={'确认进行此操作'}*/}
          {/*  // style={{ position: 'absolute', right: '0px', top: '10px' }}*/}
          {/*  onConfirm={() => {*/}
          {/*    logoutOrEnable()*/}
          {/*  }}*/}
          {/*  placement='left'*/}
          {/*  okText='确认'*/}
          {/*  cancelText='取消'*/}
          {/*>*/}
          {/*  <Button type='primary'>{queries.state ? '注销' : '启用'}</Button>*/}
          {/*</Popconfirm>*/}
        </Space>
        {/* <Button
          type='primary'
          style={{ position: 'absolute', right: '6px', top: '10px' }}
          onClick={logoutOrEnable}
        >
          {queries.state ? '注销' : '启用'}
        </Button> */}
      </Row>
      <div
        style={{
          height: 'calc(100% - 40px)',
          margin: '10px 0',
          padding: '20px',
          background: '#fff',
          borderRadius: '10px',
        }}
      >
        <Commodityquery
          materialsCategory={queries?.materialsCategory}
          filterColumn={columnQueryFilterList}
          filterSelectList={filterSelectList}
          submitPageList={((v) => {
            dispatch(setPageLoading(true))
            submitPageList(v)
            setAllColumnList(v)
          })}
          loading={pageLoadingRX}
          onValueChange={(v) => {
            setQueries({ ...queries, ...v })
          }}
        />

        <div
          id='tableHeightCommodity'
          style={{ width: '100%', height: '93%', overflowY: 'hidden' }}
        >
          <SimpleAgGrid
            rowHeight={56}
            page={{
              size: queries?.size || 10,
              current: queries?.current || 1,
              total,
              items: data,
            }}
            column={(AGColumns(
              queries.size * ((queries.current || 1) - 1),
              (text, id: number, item) => {
                if (text === 'setState') {
                  dispatch(logoutOrenableCommodity({ id: id }))
                    .then(unwrapResult)
                    .then(() => {
                      getPage()
                    })
                } else if (text === 'setStateForce' || text === 'setStateForceSameDelete') {
                  const params = text === 'setStateForceSameDelete' ? {
                    id: id, forceRemove: 1, state: 2
                  } : {
                    id: id, forceRemove: 1
                  }
                  dispatch(logoutOrenableCommodity(params))
                    .then(unwrapResult)
                    .then(() => {
                      getPage()
                    })
                } else if (text === 'edit') {
                  dispatch(setSelectId(id))
                  routerChange(item)
                } else if (text === 'insurance') {
                  if (item.approveFlg !== '1') {
                    setComponentItem(item)
                    setMedicalModalVisible(true)
                  } else {
                    notification.info({
                      message: '不可修改已上传的匹配记录!',
                    })
                  }
                  // medicalSendHttp("")
                } else if (text === 'delCode') {
                  delNedicalCode(item)
                } else if (text === 'copyCatalog') {
                  dispatch(copyCatalogAsync(id))
                    .then(unwrapResult)
                    .then((res: any) => {
                      Modal.confirm({
                        centered: true,
                        title: '确认操作',
                        content: (
                          <div>
                            <ExclamationCircleFilled
                              style={{ color: '#FFAE55', fontSize: 18 }}
                            />
                            &nbsp;复制成功，是否继续编辑新的目录？
                          </div>
                        ),
                        okText: '确认',
                        cancelText: '取消',
                        icon: null,
                        onOk: () => {
                          dispatch(setSelectId(res.id))
                          routerChange({
                            ...res,
                            materialsCategory: Number(res?.materialsCategory),
                            copyFlag: true,
                          })
                        },
                        onCancel: () => {
                          getPage()
                        },
                      })
                    })
                } else if (text === 'lastEditOperation') {
                  setLastEditVisable(true)
                  setLastEditId(id)
                } else if (text == 'firstBusssiess') {
                  getAddFirstBussiness(id)
                }
              },
              columnQueryFilterList,
              queries?.materialsCategory,
              KFGZZCKLRSJData
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoadingRX}
            pagination={true}
            pageKey={'storageStation'}
            rowSelection="multiple"
            selectedRowKeys={selectIds}
            getRowId={(data: any) => data?.id?.toString()}
            onRowDoubleClick={(event: any) => {
              const r = event?.data
              dispatch(setSelectId(r.id))
              routerChange(r)
            }}
            onRowSelected={((selected, node) => {
              const id = node?.data?.id?.toString()
              const data = node?.data
              if (selected) {
                // 去重：仅当 id 不存在时才追加（函数式更新，避免批量勾选时闭包过期）
                setSelectIds((prev: any) => (prev.includes(id) ? prev : [...prev, id]))
                setSelectRow((prev: any) =>
                  prev.some((item: any) => item?.id?.toString() === id)
                    ? prev
                    : [...prev, data]
                )
              } else {
                setSelectIds((prev: any) => prev.filter((item: any) => item !== id))
                setSelectRow((prev: any) =>
                  prev.filter((item: any) => item?.id?.toString() !== id)
                )
              }
            })}
            suppressRowClickSelection={true}
            // 配置底部行样式
            getRowStyle={(params) => {
              if (params.node.rowPinned) {
                return {
                  fontWeight: 'normal',
                  backgroundColor: '#D9F2FF',
                };
              }
              return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
            }}
            onChangePage={(current: any, size: any) => {
              setQueries({
                ...queries,
                current,
                size,
              })
            }}
            onColumnResized={(v: any) => {
              return
            }}
            onColumnMoved={(v) => {
              // dispatch(setPageLoading(true))
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
            onSortChanged={(sortModel, hasComparator) => {
              if (hasComparator) {
                console.log("sortModel", data, sortModel, hasComparator)
              } else {
                if (sortModel && sortModel.length > 0) {
                  setSorter(sortModel?.[0])
                } else {
                  setQueries({
                    ...queries,
                    lastUpdateTimeSort: undefined,
                    createTimeSort: undefined,
                  })
                }
              }
            }}
            sortedInfo={sortedInfo ? [sortedInfo] : []}
          ></SimpleAgGrid>
        </div>
      </div>
      <CommodityModal
        visible={IsModalVisible}
        title={batchModalTitle}
        onOk={() => {
          setIsModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      />
      {/* <CommodityMedicareModal
        visible={IsMedicareModalVisible}
        title={batchModalTitle}
        onOk={() => {
          setIsMedicareModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsMedicareModalVisible(false)
        }}
      /> */}
      <MedicalModal
        visible={IsMedicareModalVisible}
        isSPGL={true}
        onOk={() => {
          setIsMedicareModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsMedicareModalVisible(false)
        }}
        componentItem={{
          ...componentItem,
          insuranceCode: insuranceArray.length
            ? insuranceArray[0].insuranceCode
            : '',
        }}
      />
      <CommodityLastEditModal
        visible={lastEditVisable}
        title={'最后一次修改'}
        id={lastEditId}
        onOk={() => {
          setLastEditVisable(false)
          setLastEditId('')
        }}
        onCancel={() => {
          setLastEditVisable(false)
          setLastEditId('')
        }}
        operateType={1}
      />
      <PurchaseModal
        refresh={() => {
          getPage()
        }}
        state={2}
        isPurchaseModalVisible={isPurchaseModalVisible}
        onOk={() => {
          setIsPurchaseModalVisible(false)
        }}
        onCancel={() => {
          setIsPurchaseModalVisible(false)
        }}
      />
      <MedicalModal
        visible={medicalModalVisible}
        onOk={() => {
          setMedicalModalVisible(false)
        }}
        onCancel={() => {
          setMedicalModalVisible(false)
        }}
        onRecord={(item) => {
          setMedicalModalVisible(false)
          saveMedicalCode(item)
        }}
        componentItem={{
          ...componentItem,
          insuranceCode: queries?.insuranceCode,
        }}
      />
      <PrintTemplateModal
        templateCategory={PrintTemplateCategory.Jgbqdy}
        visible={isPrintModalVisible}
        onCancel={() => {
          setIsPrintModalVisible(false)
          setModalSelectIds([])
          setSelectIds([])
          setSelectRow([])
        }
        }
        onOk={() => setIsPrintModalVisible(false)}
        ids={selectText == '打印弹窗价签' ? modalSelectIds : selectText == '打印勾选项' ? selectIds : printIds}
      />
      {/* 一键同步限价到库存 */}
      <YJTBXJDMLKCModal
        visible={isYJTBXJDMLKCModalVisible}
        onOk={() => {
          setIsYJTBXJDMLKCModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsYJTBXJDMLKCModalVisible(false)
          setSelectIds([])
          setSelectRow([])
        }}
      />
      {/* 一键同步限价到售价 */}
      <YJTBJGModal
        flag={0}  //商品管理
        insuranceCode={queries.insuranceCode || insuranceArray[0]?.insuranceCode}
        visible={isYJTBModalVisible}
        onOk={() => {
          setIsYJTBModalVisible(false)
          getPage()
        }}
        onCancel={() => {
          setIsYJTBModalVisible(false)
          setSelectIds([])
          setSelectRow([])
        }}
      />
      {/* 价签目录打印 */}
      <PriceTagPrintModal
        printJQ={(v) => {
          if (!v.length) {
            notification.info({
              message: '请先选择商品',
            })
          } else {
            setSelectText('打印弹窗价签')
            setIsPrintModalVisible(true)
            setModalSelectIds(v)
          }
        }}
        deleteJQ={(v) => {
          if (!v.length) {
            notification.info({
              message: '请先选择商品',
            })
          } else {
            getDeleteJQ(v)
          }
        }}
        clearAllJQ={() => {
          getDeleteJQ()
          // setTimeout(() => {
          //   setIsPriceTagPrintModalVisible(false)
          // }, 500)
        }}
        deleteRow={(id) => {
          getDeleteJQ([id])
        }}
        ref={priceTagPrintModalRef}
        visible={isPriceTagPrintModalVisible}
        onCancel={() => setIsPriceTagPrintModalVisible(false)}
        onOk={() => setIsPriceTagPrintModalVisible(false)}
      />
    </div>
  )
}
